import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=44701f86&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44701f86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44701f86')) {
      api.createRecord('44701f86', component.options)
    } else {
      api.reload('44701f86', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=44701f86&scoped=true&", function () {
      api.rerender('44701f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21g3Gvq3imkY8/JS/comp/Accordion.vue"
export default component.exports